import { Injectable } from "@angular/core";
import { TauriService } from "./tauri.service";
import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs";
import { HandleError } from "src/app/utils/network-error-handler";

@Injectable()
export class TauriCashdeskDatasService {
  constructor(
    private _tauriService: TauriService,
    private _httpClient: HttpClient
  ) {}

  doGetCashdeskPParamsDatasAction(queryParams: QueryParams_CoreTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/pparams/get', Object.assign({ PAGINATED: true, PAGESIZE: 1, PAGENUMBER: 1 }, queryParams)).pipe(map(items => items.length > 0 ? items[0] : null), catchError(error => HandleError(error)));
  }

  doGetCashdeskFnParamsDatasAction(queryParams: QueryParams_CoreTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/fnparams/get', Object.assign({ PAGINATED: true, PAGESIZE: 1, PAGENUMBER: 1 }, queryParams)).pipe(map(items => items.length > 0 ? items[0] : null), catchError(error => HandleError(error)));
  }

  doGetCashdeskVxParamsDatasAction(queryParams: QueryParams_CoreTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/vxparams/get', Object.assign({ PAGINATED: true, PAGESIZE: 1, PAGENUMBER: 1 }, queryParams)).pipe(map(items => items.length > 0 ? items[0] : null), catchError(error => HandleError(error)));
  }

  doGetCashdeskPDevisesDatasAction(queryParams: QueryParams_PDeviseTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/pdevises/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFTarifsDatasAction(queryParams?: QueryParams_CoreTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/ftarif/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFTarifsSelectDatasAction(queryParams?: QueryParams_CoreTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/ftarifselect/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFDepotsDatasAction(queryParams?: QueryParams_FDepotTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/fdepot/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskPSouchesVenteDatasAction(queryParams?: QueryParams_PSoucheVenteTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/psouchevente/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFCompteADatasAction(queryParams?: QueryParams_FCompteATauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/fcomptea/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFClientsDatasAction(queryParams?: QueryParams_FClientTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/fclients/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFCollaborateursDatasAction(queryParams?: QueryParams_FCollaborateurTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/fcollaborateurs/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFArticlesDatasAction(queryParams?: QueryParams_FArticleTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/farticles/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFArtEnumRefsDatasAction(queryParams?: QueryParams_FArtEnumRefTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/fartenumrefs/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFConditionsDatasAction(queryParams?: QueryParams_FConditionTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/fconditions/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFNomenclaturesDatasAction(queryParams?: QueryParams_FNomenclatureTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/fnomenclatures/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFArtClientDatasAction(queryParams: QueryParams_FArtClientTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/fartclients/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFArtComptaDatasAction(queryParams: QueryParams_FArtComptaTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/fartcomptas/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFTarifgamDatasAction(queryParams: QueryParams_FTarifgamTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/ftarifgam/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFTarifcondDatasAction(queryParams: QueryParams_FTarifcondTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/ftarifcond/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFTarifqteDatasAction(queryParams: QueryParams_FTarifqteTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/ftarifqte/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFFamcomptaDatasAction(queryParams: QueryParams_FFamcomptaTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/ffamcompta/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFFamclientDatasAction(queryParams: QueryParams_FFamclientTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/ffamclient/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFFamtarifDatasAction(queryParams: QueryParams_FFamtarifTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/ffamtarif/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFFamtarifqteDatasAction(queryParams: QueryParams_FFamtarifqteTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/ffamtarifqte/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFModeleDatasAction(queryParams?: QueryParams_FModeleTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/fmodele/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskFArtModeleDatasAction(queryParams: QueryParams_FArtModeleTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/fartmodele/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskCbsyslibreDatasAction(queryParams: QueryParams_CbsyslibreTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/cbsyslibre/get', queryParams).pipe(catchError(error => HandleError(error)));
  }

  doGetCashdeskPDossierDatasAction(queryParams?: QueryParams_CoreTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/pdossier/get', Object.assign({ PAGINATED: true, PAGESIZE: 1, PAGENUMBER: 1 }, queryParams)).pipe(map(items => items.length > 0 ? items[0] : null), catchError(error => HandleError(error)));
  }

  doGetCashdeskCluzticktraceAction(queryParams: QueryParams_CluzticktraceTauriData) {
    return this._httpClient.post<any[]>(this._tauriService.tauriEndpointUrl + '/api/cashdesk/datas/cluzticktrace/get', queryParams).pipe(catchError(error => HandleError(error)));
  }
}

// #region QueryParams
export class QueryParams_CoreTauriData {
  CBMARQ?: number;

  PAGINATED?: boolean;
  PAGESIZE?: number;
  PAGENUMBER?: number;

  SORT_COLUMN?: string;
  SORT_DIRECTION?: "ASC" | "DESC";
  DEBUG?: boolean;
}

export class QueryParams_PDeviseTauriData extends QueryParams_CoreTauriData {
  D_MAIN?: number;
}

export class QueryParams_FDepotTauriData extends QueryParams_CoreTauriData {
  DE_NO?: number;
  DE_PRINCIPAL_F?: boolean;
}

export class QueryParams_PSoucheVenteTauriData extends QueryParams_CoreTauriData {
  SV_PRINCIPAL_F?: boolean;
  DO_SOUCHE?: number;
}

export class QueryParams_FCompteATauriData extends QueryParams_CoreTauriData {
  CA_NUM?: string;
  IS_AFFAIRE?: number;
}

export class QueryParams_FClientTauriData extends QueryParams_CoreTauriData {
  CT_NUM?: string;
  CO_NO?: number;
  COLLABORATEUR_ONLY?: boolean;
  SEARCH?: string;
}

export class QueryParams_FCollaborateurTauriData extends QueryParams_CoreTauriData {
  CO_NO?: number;
}

export class QueryParams_FArticleTauriData extends QueryParams_CoreTauriData {
  AR_REF?: string;
  SEARCH?: string;
}

export class QueryParams_FArtEnumRefTauriData extends QueryParams_CoreTauriData {
  AE_CODEBARRE?: string;
}

export class QueryParams_FConditionTauriData extends QueryParams_CoreTauriData {
  AR_REF?: string;
  CO_CODEBARRE?: string;
}

export class QueryParams_FNomenclatureTauriData extends QueryParams_CoreTauriData {
  AR_REF?: string;
}

export class QueryParams_FArtClientTauriData extends QueryParams_CoreTauriData {
  AR_REF: string;
}

export class QueryParams_FArtComptaTauriData extends QueryParams_CoreTauriData {
  AR_REF: string;
}

export class QueryParams_FTarifgamTauriData extends QueryParams_CoreTauriData {
  AR_REF: string;
}

export class QueryParams_FTarifcondTauriData extends QueryParams_CoreTauriData {
  AR_REF: string;
}

export class QueryParams_FTarifqteTauriData extends QueryParams_CoreTauriData {
  AR_REF: string;
}

export class QueryParams_FFamcomptaTauriData extends QueryParams_CoreTauriData {
  FA_CODEFAMILLE?: string;
}

export class QueryParams_FFamclientTauriData extends QueryParams_CoreTauriData {
  CT_NUM?: string;
  FA_CODEFAMILLE?: string;
}

export class QueryParams_FFamtarifTauriData extends QueryParams_CoreTauriData {
  FA_CODEFAMILLE?: string;
  FT_CATEGORIE?: string;
}

export class QueryParams_FFamtarifqteTauriData extends QueryParams_CoreTauriData {
  FA_CODEFAMILLE?: string;
  FQ_REFCF?: string[];
}

export class QueryParams_FModeleTauriData extends QueryParams_CoreTauriData {
}

export class QueryParams_FArtModeleTauriData extends QueryParams_CoreTauriData {
  AR_REF: string;
}

export class QueryParams_CbsyslibreTauriData extends QueryParams_CoreTauriData {
  CB_FILE?: string;
}

export class QueryParams_CluzticktraceTauriData extends QueryParams_CoreTauriData {
  DO_PIECE_INTERNAL?: string;
}
// #endregion
